/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/


import React, { useEffect, useState } from "react";
import FormControl from "@mui/material/FormControl";
import { Controller } from "react-hook-form";
import { InputFieldProps } from "../../types/InputProps";
import TextField from "@mui/material/TextField"; 
import InputWrapper from "./InputWrapper";
import styled from "styled-components";

const TextStyle = styled(TextField)`
  input {
    height: 39px;
  }
  label {
    line-height: 2.5;
  }
  .MuiInputLabel-shrink {
    line-height: 1.52;
  }
`;

const formatPhoneNumber = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);
  if (digits.length === 0) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const FormPhoneText = (props: InputFieldProps) => {
  const { name, control, info, hint, meta, label = [] } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const [inputValue, setInputValue] = useState(formatPhoneNumber(value || ""));

        useEffect(() => {
          setInputValue(formatPhoneNumber(value || ""));
        }, [value]);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const raw = e.target.value.replace(/\D/g, "").slice(0, 10);
          setInputValue(formatPhoneNumber(raw));
          onChange(raw);
        };

        return (
          <InputWrapper info={info} hint={hint} error={error}>
            <FormControl fullWidth>
              <TextStyle
                aria-label={label}
                variant="outlined"
                error={!!error}
                value={inputValue}
                label={props.label}
                onChange={handleChange}
                placeholder="(123) 456-7890"
                {...meta}
              />
            </FormControl>
          </InputWrapper>
        );
      }}
    />
  );
};

export default FormPhoneText;

  